import React from "react";
import {FontAwesomeIcon}            from "@fortawesome/react-fontawesome";


import "./empty-search.scss";


export const EmptySearch = ({queryParam}) => {
    

    return (
        <div className="empty-search-bcf589">
            <FontAwesomeIcon
                icon={require('@fortawesome/free-solid-svg-icons')['faMagnifyingGlass']}
                className="icon"
            />
            <div className="header">
                No Results Found
            </div>
            <TextNoResults {...{queryParam}} />
            <button
                className="new-search"
                onClick={(e) => {
                    e.stopPropagation()

                }}
            >
                Start New Search
            </button>
        </div>
    )
}

const TextNoResults = ({queryParam}) => {
    const textBasic = "Hmm... seems like we couldn't find anything"
    if(!queryParam) {
        return <div className="sub-header">{textBasic}</div>
    }

    return  (
        <div className="sub-header">
            {`${textBasic} for `}<strong>"{queryParam}"</strong>
        </div>
    )
}